/**
 * GraphQL Query
 * 任天堂_構成品目画面
 */

/**
 * 構成品目一覧
 */
export const GRAPH_QL_QUERY_N_COMPONENT_LIST =
`
  query {
    NComponent ( ? ) {
      edges {
        node {
          setItemCode
          setItemComponentType
          itemList {
            componentItemCode
            componentItemType
            componentItemNumber
            isBody
            updatedAt
            isActive
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/nintendo/masterComponent.js